<template>
  <section class="related-field" v-if="fieldData.length">
    <!-- 標題 -->
    <h3 class="field__title">
      <img src="../../assets/images/article/album.svg" alt="" />
      {{ titleImage.alt }}
    </h3>
    <!-- 相片、圖鑑集 -->
    <AlbumCollection
      :coverings="fieldData"
      displayType="album"
      :isUsedInArticle="true"
    >
      <template v-slot:title="album">
        <!-- 銜接相簿的標題，album 是 slotProp -->
        <h4>{{ album.cover.title }}</h4>
      </template>
      <slot name="moreArticles"></slot>
    </AlbumCollection>
  </section>
</template>

<script>
import AlbumCollection from '@/components/AlbumCollection';
export default {
  name: 'ArticleRelatedField',
  props: {
    displayType: {
      type: String,
      default: '',
    },
    linkPath: {
      type: String,
      default: '',
    },
    titleImage: {
      type: Object,
      default: () => {
        return { src: '123.png', alt: '圖鑑集' };
      },
    },
    fieldData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getTwoPhotosOfAlbum: function(album) {
      return album.slice(0, 2);
    },
  },
  components: {
    AlbumCollection,
  },
};
</script>
